// extracted by mini-css-extract-plugin
export default {"tableContainer":"ArticleTable_tableContainer__J2RGy","content":"ArticleTable_content__gp17h","icon":"ArticleTable_icon__cZLvR"};